// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";

export function Modal(props) {

    const [id, setId] = useState(uuidv4())
    const firstRender = useRef(true);

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            ((c ^ crypto.getRandomValues(new Uint8Array(1))[0]) & (15 >> c / 4)).toString(16)
        );
    }

    useEffect(() => {
        if (props.isOpen) {
            // eslint-disable-next-line no-undef
            UIkit.modal(document.getElementById(id)).show();

            if (firstRender.current)
                firstRender.current = false;
        }

        else if (!firstRender.current) {
            // eslint-disable-next-line no-undef
            UIkit.modal(document.getElementById(id)).hide();

        }
    }, [props.isOpen])


    let classNameDialog = "uk-modal-dialog"
    if (props.centered) {
        classNameDialog += " uk-margin-auto-vertical"
    }

    let classNameModal = "uk-flex-top"
    switch (props.id) {
        case "md": break;

        case "lg":
            classNameModal += " uk-modal-container"
            break;

        case "xl":
            classNameDialog += " uk-width-xlarge"
            break;

        case "sm":
            classNameDialog += " uk-width-large"
            break;

        default: break;
    }

    return (
        <div id={id} className={classNameModal} data-uk-modal="bg-close: false; container: false; esc-close: false">
            <div className={classNameDialog}>
                {props.children}
            </div>
        </div>
    )
}

export function ModalHeader({ children, className, id }) {
    if (typeof children === "object")
        return (
            <div className={"uk-modal-header " + (className || "")} id={id}>
                {children}
            </div>
        )

    return (
        <div className={"uk-modal-header " + (className || "")} id={id}>
            <h2 className="uk-modal-title">{children}</h2>
        </div>
    )
}

export function ModalBody({ children, className, id }) {
    return (
        <div className={"uk-modal-body " + (className || "")} id={id}>
            {children}
        </div>
    )
}

export function ModalFooter({ children, className }) {
    return (
        <div className={"uk-modal-footer " + (className || "")}>
            {children}
        </div>
    )
}